import { ReferralCancelReasonKey } from './ReferralCancelReasonKey';

// Where the patient's consent to the referral stands, stated by whoever refers
// the member (see ReferralConsentSchema): `pending` for a consent we still have
// to obtain — the referral is held until we do — and `given` for one already in
// hand. The other two are outcomes of asking, recorded by us.
export enum ReferralConsentStatus {
  pending = 'pending',
  given = 'given',
  refused = 'refused',
  // Asked for, never reached — no answer to the telephone call
  unreachable = 'unreachable',
}

export function displayReferralConsentStatus(value: ReferralConsentStatus) {
  switch (value) {
    case ReferralConsentStatus.pending:
      return 'Pending';
    case ReferralConsentStatus.given:
      return 'Given';
    case ReferralConsentStatus.refused:
      return 'Refused';
    case ReferralConsentStatus.unreachable:
      return 'Could not be reached';
    default:
      throw new Error(`Unknown referral consent status: ${value}`);
  }
}

// The statuses that end the referral, and the reason each cancels it with —
// the single source of truth for "this referral ended on the patient's
// consent" (see onCancelReferralSendEmailToReferrerUnableProceed).
export type ReferralConsentCancellingStatus =
  ReferralConsentStatus.refused | ReferralConsentStatus.unreachable;

export const referralConsentCancelReasonKeys: Record<
  ReferralConsentCancellingStatus,
  ReferralCancelReasonKey
> = {
  [ReferralConsentStatus.refused]:
    ReferralCancelReasonKey.patient_declined_consent,
  [ReferralConsentStatus.unreachable]:
    ReferralCancelReasonKey.patient_no_answer,
};
